import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { useFlags } from "launchdarkly-react-client-sdk";
import mixpanel from "mixpanel-browser";
import React from "react";
import { useNavigate } from "react-router-dom";

import HeaderSection from "./HeaderSection";
import NewNoteButton from "./NewNoteButton";
import Note from "./Note";
import NoteMultiSelector from "./NoteMultiSelector";
import FullScreenLoading from "../../common/loading/FullScreenLoading";
import { DeleteMultiModal } from "../../common/multiselect/DeleteMultiModal";
import { MultiSelectActionContainer } from "../../common/multiselect/MultiSelectActionContainer";
import { QuickActionInstructionText } from "../../common/multiselect/QuickActionInstructionText";

function EmptyState() {
  return (
    <div key={0}>
      <div className="p-5 bg-secondary rounded-large">
        <div className="flex flex-col self-center justify-self-center space-y-5">
          <h4 className="text-center text-base text-secondary">
            There&apos;s nothing here yet!
          </h4>
          <h5 className="text-center text-xs md:text-sm text-secondary">
            You have not created any notes for this patient yet.{" "}
            <br /> Try recording an appointment above!
          </h5>
        </div>
      </div>
    </div>
  );
}

function Notes(props) {
  const navigate = useNavigate();
  const { useLegacyNotes } = useFlags();
  const {
    patientUUID,
    isPageLoading,
    isRecording,
    patient,
    refetch,
  } = props;

  let listItems = null;

  if (patient) {
    if (patient?.notes?.length === 0) {
      listItems = (
        <div key={0}>
          <EmptyState />
        </div>
      );
    } else {
      listItems = patient?.notes?.map((note, index) => (
        <div
          key={index}
          className="flex flex-row w-full"
          id={`notesCard-${index}`}
        >
          <NoteMultiSelector
            checkBoxItemUuid={note?.uuid}
            icon={faBolt}
            tooltipText="Select this note for ⚡️ Quick Actions"
            isPatient={note?.patient ? true : false}
          >
            <Note
              note={note}
              user={patient?.user}
              patientData={patient}
            />
          </NoteMultiSelector>
        </div>
      ));
    }
  }

  return (
    <div>
      <DeleteMultiModal notes={patient?.notes} refetch={refetch} />
      <HeaderSection {...props} />
      <FullScreenLoading loadingTrigger={isPageLoading} />
      {listItems?.length > 0 ? <QuickActionInstructionText /> : null}
      {useLegacyNotes && (
        <div className="w-full mb-4" id="newNotePatientNotebook">
          <NewNoteButton
            onClick={() => {
              mixpanel.track("New Patient Note");
              navigate(`/new_note/patient/${patientUUID}`);
            }}
            disabled={isRecording}
          />
        </div>
      )}
      <div>
        <ul className="space-y-4">{listItems}</ul>
      </div>
      <MultiSelectActionContainer
        notes={patient?.notes}
        refetch={refetch}
      />
    </div>
  );
}

export default Notes;
